export const BLOG_CONTAINER_THEME_LIST = ['default', 'dark-navy', 'navy', 'grey', 'light-grey'];
export const BLOG_CONTAINER_WIDTH_LIST = ['default', 'short', 'narrow'];
